// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"797c7af6","488":"6a15b07e","732":"2e42cedd"}[chunkId] + ".chunk.js";
};